// @flow

import { STATUS_LOADING, STATUS_FAILURE, STATUS_SUCCESS, STATUS_DEFAULT } from 'constants/statusConstants';
import {
  FETCH_ALL_ARTICLES_START,
  FETCH_ALL_ARTICLES_SUCCESS,
  FETCH_ALL_ARTICLES_FAILURE,
} from 'actions/articlesActions';

import type { ArticleType } from 'types/Article';
import type { Status } from 'types/Status';
import type { ActionType } from 'types/Actions';

export type State = {
  articles: Array<ArticleType>,
  status: Status
};

const initialState: State = {
  articles: [],
  status: STATUS_DEFAULT
};

export default function(state: State = initialState, action: ActionType): State {
  switch (action.type) {
    case FETCH_ALL_ARTICLES_START:
      return {
        ...state,
        status: STATUS_LOADING,
        articles: []
      };
    case FETCH_ALL_ARTICLES_SUCCESS:
      return {
        ...state,
        articles: action.payload.articles,
        status: STATUS_SUCCESS
      };
    case FETCH_ALL_ARTICLES_FAILURE:
      return {
        ...state,
        article: [],
        status: STATUS_FAILURE
      };
    default:
      return state;
  }
}
